<template>
    <div>
        <breadcrumbs
            :title="'Vrste prometa'"
            :breadcrumbs="breadcrumbs"
        ></breadcrumbs>
        <div class="ibox">
            <div class="ibox-title">
                <h5>Vrste prometa: {{ naziv }}</h5>
            </div>
            <div class="ibox-content">
                <vrsta-prometa-forma
                    :disabled="true"
                    :id="id"
                    :modal="false"
                    :action="'show'"
                    @returnData="setData"
                ></vrsta-prometa-forma>
            </div>
        </div>
    </div>
</template>

<script>
import Breadcrumbs from "../../../../components/breadcrumbs/Breadcrumbs";
import VrstaPrometaForma from "./VrstaPrometaForma";
export default {
    name: "VrstaPrometaDetails",
    components: {
        VrstaPrometaForma,
        Breadcrumbs
    },
    data(){
        return {
            id: this.$route.params.vrsta_prometa_id,
            breadcrumbs: [],
            naziv: ''
        }
    },
    methods: {
        setBreadcrumbs(){
            this.breadcrumbs = [
                {
                    path: '/postavke/vrste-prometa',
                    name: 'Vrste prometa'
                },
                {
                    path: '/postavke/vrste-prometa/' + this.id,
                    name: 'Vrsta prometa: ' + this.naziv
                }
            ]
        },
        setData( data ){
            this.naziv = data.naziv || ''
            this.setBreadcrumbs()
        }
    }
};
</script>

<style scoped>

</style>
